module.exports = __webpack_public_path__ + "img/wallet.b0bf81cf.svg";